var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
var locals_ = (locals || {}),name = locals_.name,collection = locals_.collection,title = locals_.title,count = locals_.count;
var jade_indent = [];
buf.push("\n<li><a" + (jade.attr("href", "#/record/" + (name) + "", true, false)) + " class=\"record\">");
if (collection)
{
buf.push("<span class=\"fa fa-angle-double-right\"></span>");
}
else
{
buf.push("<span class=\"fa fa-table\"></span>");
}
buf.push("" + (jade.escape((jade_interp = title) == null ? '' : jade_interp)) + "\n    <div" + (jade.attr("id", "count-" + (name) + "", true, false)) + " class=\"label label-default\">" + (jade.escape((jade_interp = count) == null ? '' : jade_interp)) + "</div></a><a" + (jade.attr("href", "#/schema/" + (name) + "", true, false)) + " class=\"schema\"><span class=\"fa fa-chevron-right\"></span></a></li>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}